/* eslint-disable global-require */
import { TextureLoader } from 'curtainsjs';

export const firstTextureGroup = [
	{ name: 'billboard1-1', file: 'https://res.cloudinary.com/paystack/video/upload/public/files/products/k7xfhg34nfvj7h23l4e8.mp4' },
	{ name: 'billboard1-2', file: 'https://res.cloudinary.com/paystack/video/upload/public/files/products/5i2cuvz12yeikx5xo2nu.mp4' },
	{ name: 'billboard1-3', file: 'https://res.cloudinary.com/paystack/video/upload/public/files/products/6sfytmri21wjj05bu2ie.mp4' },
	{ name: 'billboard1-4', file: 'https://res.cloudinary.com/paystack/video/upload/public/files/products/dgdtxmghyv1on85ah9py.mp4' },
	{ name: 'billboard2-1', file: 'https://res.cloudinary.com/paystack/video/upload/public/files/products/wivw6ns9deu1qj54orld.mp4' },
	{ name: 'billboard2-2', file: 'https://res.cloudinary.com/paystack/video/upload/public/files/products/roc09qouy1gacbe9stie.mp4' },
	{ name: 'billboard2-3', file: 'https://res.cloudinary.com/paystack/video/upload/public/files/products/9tnfhn32rblfmfemtyqu.mp4' },
	{ name: 'billboard3-1', file: 'https://res.cloudinary.com/paystack/video/upload/public/files/products/des1svgzdwll5kworp1s.mp4' },
	{ name: 'billboard3-2', file: 'https://res.cloudinary.com/paystack/video/upload/public/files/products/al8vp8cylqmzc96rjdsl.mp4' },
	{ name: 'billboard3-3', file: 'https://res.cloudinary.com/paystack/video/upload/public/files/products/q1oiws0hut0no8p0ilfm.mp4' },
];

export const lastTextureGroup = [
	{ name: 'section2-1', file: 'https://res.cloudinary.com/paystack/video/upload/public/files/products/419wz35npubri59eiift.mp4' },
	{ name: 'section3-1', file: 'https://res.cloudinary.com/paystack/video/upload/public/files/products/x79glk01evjnap59g72p.mp4' },
	{ name: 'section1-1', file: 'https://res.cloudinary.com/paystack/video/upload/public/files/products/5v28t0ch48gp394ewiqf.mp4' },
	{ name: 'section1-2', file: 'https://res.cloudinary.com/paystack/video/upload/public/files/products/uvh1zdcywiuqyyljuwi9.mp4' },
	{ name: 'section1-3', file: 'https://res.cloudinary.com/paystack/video/upload/public/files/products/jdqmbmpndihw2e5fcgdi.mp4' },
];

const setVideo = file => {
	const videoEl = document.createElement('video');
	videoEl.src = file;
	videoEl.crossOrigin = 'anonymous';
	videoEl.setAttribute('playsinline', '');
	videoEl.setAttribute('loop', '');
	videoEl.setAttribute('muted', '');
	videoEl.setAttribute('autoplay', '');
	videoEl.setAttribute('disablePictureInPicture', '');

	return videoEl;
};

export default class Preloader {
	constructor({ curtains }) {
		this.loader = new TextureLoader(curtains);

		this.loaded = 0;

		this.fetchInitial();
		window.TEXTURES = {};
	}

	fetchInitial() {
		const videos = firstTextureGroup.map(video => {
			const videoEl = setVideo(video.file);

			return videoEl;
		});

		this.loader.loadVideos(
			videos,
			{
				sampler: 'uTexture',
			},
			texture => {
				const textureName = firstTextureGroup.find(video => video.file === texture.source.getAttribute('src')).name;

				window.TEXTURES = {
					...window.TEXTURES,
					[textureName]: texture,
				};
			},
		);
	}

	fetchRest() {
		const videos = lastTextureGroup.map(video => {
			const videoEl = setVideo(video.file);

			return videoEl;
		});

		this.loader.loadVideos(
			videos,
			{
				sampler: 'uTexture',
			},
			texture => {
				const textureName = lastTextureGroup.find(video => video.file === texture.source.getAttribute('src')).name;

				window.TEXTURES = {
					...window.TEXTURES,
					[textureName]: texture,
				};
			},
		);
	}
}
